import React from 'react';
import * as Slices from './slices';

export const SliceZone = ({ allSlices = [], openedPostCareers, categoriesCareers }) => {
  const slices = allSlices.map((s, index) => {
    const key = s.id ? s.id : `${s.slice_type}-${index}`;
    const next_slice_type = allSlices[index + 1]?.slice_type;
    const common = { next_slice_type };

    switch (s.slice_type) {
      case 'hero':
        return <Slices.Hero key={key} {...s} {...common} />;
      case 'editorial':
        return <Slices.Editorial key={key} {...s} {...common} />;
      case 'text':
        return <Slices.Text key={key} {...s} {...common} />;
      case 'testimonials':
        return <Slices.Testimonials key={key} {...s} {...common} />;
      case 'push':
        return <Slices.Push key={key} {...s} {...common} />;
      case 'thumbnails':
        return <Slices.Thumbnails key={key} {...s} {...common} />;
      case 'thumbnail_full':
        return <Slices.ThumbnailFull key={key} {...s} {...common} />;
      case 'list':
        return <Slices.List key={key} {...s} {...common} />;
      case 'gallery':
        return <Slices.Gallery key={key} {...s} {...common} />;
      case 'credits':
        return <Slices.Credits key={key} {...s} {...common} />;
      case 'gallery_scroll':
        return <Slices.GalleryScroll key={key} {...s} {...common} />;
      case 'relateds':
        return <Slices.Relateds key={key} {...s} {...common} />;
      case 'carousel_push':
        return <Slices.CarouselPush key={key} {...s} {...common} />;
      case 'vimeo':
        return <Slices.Vimeo key={key} {...s} {...common} />;
      case 'logos':
        return <Slices.Logos key={key} {...s} {...common} />;
      default:
        return null;
    }
  });

  return slices;
};
